import { LiveHubService } from '../../services/livehub.service';
import { LicenseManager } from '../../managers/License.manager';
import { Title } from '@angular/platform-browser';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { PinService } from '../../services/pin.service';
import { AddNotePromptDialog } from '../add.note.prompt/add.note.prompt.dialog';
import { UserRolesService } from '../../services/user.roles.service';
import { Router } from '@angular/router';
import { SubscribeToLicenseRequest } from '@models/ss-api/requests/subscribe.to.license.request';
import { LiveHubConnectionStatuses } from '@models/domain/license';

export interface ILicenseDetailsDialogModel {
    licenseManager: LicenseManager;
}

@Component({
    selector: 'license-details-dialog',
    styleUrls: ['./license.details.dialog.css'],
    templateUrl: './license.details.dialog.html'
})
export class LicenseDetailsDialog extends DialogComponent<ILicenseDetailsDialogModel, boolean> implements ILicenseDetailsDialogModel, OnInit, OnDestroy {

    Stage: number;
    StagePercentage: number;
    TimeRemaining: number;
    DownloadSpeed: number;

    licenseManager: LicenseManager;
    private originalTitle: string;

    constructor(dialogService: DialogService, private titleService: Title, private pinService: PinService, public roles: UserRolesService, public router: Router, private liveHub: LiveHubService) {
        // we call the pinservice tomake sure we load the service init
        super(dialogService, router);
    }
    ngOnInit() {
        this.originalTitle = this.titleService.getTitle();
        if (this.licenseManager.newEntity) {
            this.titleService.setTitle(this.licenseManager.newEntity.License.Key);
        }
        this.pinService.Refresh();
        this.InitUpdaterStatus();
    }

    ngOnDestroy() {
        this.titleService.setTitle(this.originalTitle);
    }

    private InitUpdaterStatus() {
        var request = new SubscribeToLicenseRequest();
        request.VerboseUpdates = true;
        request.LicenseKey = this.licenseManager.newEntity.License.Key;
        this.liveHub.InvokeConnection('SubscribeToLicense', request);

        let disposable = this.liveHub.LicenseStatusUpdate.subscribe(response => {
            this.Stage = response.stage;
            this.StagePercentage = response.percent;
            this.TimeRemaining = response.estimatedSecondsRemaining;
            this.DownloadSpeed = response.speed;
        })

        let connectionStatusDisposable = this.liveHub.LicenseConnectionStatusUpdate.subscribe(response => {
            //Check to ensure that the license matches - we'll be subscribed to all of this member's licenses
            if (this.licenseManager.newEntity.License.Key == response.LicenseKey){
                
                //We match - let's set the properties
                if (response.IsConnected){
                    this.licenseManager.License().LiveHubConnectionStatus = LiveHubConnectionStatuses.Connected;
                }
                else{
                    this.licenseManager.License().LiveHubConnectionStatus = LiveHubConnectionStatuses.NotConnected;
                }

                this.licenseManager.License().LiveHubVersion = response.UpdaterVersion;
                this.licenseManager.License().LiveHubDateTimeConnectionStarted = new Date(response.DateTimeConnectionStarted);
                this.licenseManager.License().LiveHubDateTimeConnectionStopped = new Date(response.DateTimeConnectionStopped);
            }
        })

        this.Subscriptions.push(disposable);
        this.Subscriptions.push(connectionStatusDisposable);
    }

    confirm() {

        let disposable = this.dialogService.addDialog(AddNotePromptDialog, {
            title: 'Edit License Note',
            showCancel: true
        }, {
                width: 400,
                height: 500,
                IsRequired: true
            }).subscribe(result => {
                disposable.unsubscribe();

                if (result == 'cancel') {
                    return;
                } else {
                    // update note parameter here:
                    let newNote = result;

                    this.licenseManager.SaveChanges(true, true, newNote);

                    let saved = this.licenseManager.OnChangesSaveResponse.subscribe(response => {
                        saved.unsubscribe();

                        if (response.Result)
                            this.closeOK();
                    });
                }

            });

    }

    NameForStage() {
        switch (this.Stage) {
            case 0:
                return 'Idle';
            case 1:
                return 'Downloading';
            case 2:
                return 'Extracting';
            case 3:
                return 'Applying';
            case 4:
                return 'Unkown';
            case 5:
                return 'Working';
            case 6:
                return 'Reverting';
        }
    }

    WidthForPercentage() {
        return this.StagePercentage + '%';
    }

    closeOK() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.liveHub.InvokeConnection('UnsubscribeFromLicense', this.licenseManager.License().Key);
        // this.liveHub.StartConnection();
        this.result = true;
        this.close();

    }

    NavigateToMember(newMemberID: number) {
        this.licenseManager.NavigateToMember(newMemberID);
    }

    onMemberClick(id: number) {
        this.router.navigate(['/member-profile', id]);
    }

    ColorForScore(score: number) {
        if (score < 4939) {
            return '#ed5565';
        } else if (score < 13344) {
            return '#d6d618';
        } else  {
            return '#1cb91c';
        }
    }

}
